/**
 * Created by sasik on 10/13/15.
 */

/**
 * ajax handler
 * @type {{destroy: Function}}
 */
var Api = {
    destroy: function (type, id, csrfToken, doneCallback, failCallback, alwaysCallback, method) {
        var url = '/frontend/api/' + type + '/' + id;
        //console.log(url);
        $.ajax({
            url: url,
            method: method,
            data: {
                '_token': csrfToken
            }
        })
        .done(function (data) {
            console.log('Done');
            doneCallback?doneCallback(data):'';
        })
        .fail(function (jqXHR, textStatus) {
            console.log('Fail: ' + textStatus);
            failCallback?failCallback():'';
        })
        .always(function () {
            console.log('Always');
            alwaysCallback?alwaysCallback():'';
        });
    },
    destroyUrl: function (url, csrfToken, doneCallback, failCallback, alwaysCallback, method) {
        //console.log(url);
        $.ajax({
            url: url,
            method: method,
            data: {
                '_token': csrfToken
            }
        })
            .done(function (data) {
                console.log('Done');
                doneCallback?doneCallback(data):'';
            })
            .fail(function (jqXHR, textStatus) {
                console.log('Fail: ' + textStatus);
                failCallback?failCallback():'';
            })
            .always(function () {
                console.log('Always');
                alwaysCallback?alwaysCallback():'';
            });
    },
    publish:function(model,id, doneCallback, failCallback, alwaysCallback)
    {
        var url = '/publish-service/publish/' + model + '/' + id;
        var reason = $("textarea[name=reason_text_"+model+'publish'+id+"]").val();
        console.log("textarea[name=reason_text_"+model+id+"]",reason);

        $.ajax({
                url: url,
                method: 'get',
                data: {
                    reason:reason
                }
            })
            .done(function (data) {
                console.log('Done');
                doneCallback?doneCallback(data):'';
            })
            .fail(function (jqXHR, textStatus) {
                console.log('Fail: ' + textStatus);
                failCallback?failCallback():'';
            })
            .always(function () {
                console.log('Always');
                alwaysCallback?alwaysCallback():'';
            });
    },
    unpublish:function(model,id, doneCallback, failCallback, alwaysCallback)
    {
        var url = '/publish-service/unpublish/' + model + '/' + id;
        var reason = $("textarea[name=reason_text_"+model+'unpublish'+id+"]").val();
        console.log("textarea[name=reason_text_"+model+id+"]",reason);
        $.ajax({
                url: url,
                method: 'get',
                data: {
                    reason:reason
                }
            })
            .done(function (data) {
                console.log('Done');
                doneCallback?doneCallback(data):'';
            })
            .fail(function (jqXHR, textStatus) {
                console.log('Fail: ' + textStatus);
                failCallback?failCallback():'';
            })
            .always(function () {
                console.log('Always');
                alwaysCallback?alwaysCallback():'';
            });
    },
    custom:function(model,id,action, doneCallback, failCallback, alwaysCallback)
    {
        var url = '/publish-service/custom/'+action+'/' + model + '/' + id;
        var reason = $("textarea[name=reason_text_"+model+action+id+"]").val();
        console.log("textarea[name=reason_text_"+model+action+id+"]",reason);
        $.ajax({
            url: url,
            method: 'get',
            data: {
                reason:reason
            }
        })
            .done(function (data) {
                console.log('Done');
                doneCallback?doneCallback(data):'';
            })
            .fail(function (jqXHR, textStatus) {
                console.log('Fail: ' + textStatus);
                failCallback?failCallback():'';
            })
            .always(function () {
                console.log('Always');
                alwaysCallback?alwaysCallback():'';
            });
    }
};

/**
 * Intercepts sending form
 * do it with ajax
 * all models must have rest api controllers with method @destroy($id)
 * URI: /api/[controller_name]/[id]
 */

var AjaxDeleteForm=function (event) {

    event.preventDefault();
    var $form = $($(this).closest("form")[0]);

    var type = '',
        id = 0,
        csrfToken = '';
    var params = $form.serializeArray();
    var len = params.length;
    for(var i = 0; i < len; i++) {
        if (params[i].name == 'type') {
            type = params[i].value;
        } else if (params[i].name == 'id') {
            id = params[i].value;
        } else if (params[i].name == '_token') {
            csrfToken = params[i].value;
        }
    }

    var doneCallback = function (data) {
        $('.logs').empty().append('<div class="alert alert-info">' + data.message + '</div>');
        if(!data.nodelete)
            $form.parents('tr').remove();
    };
    var failCallback = function () {
        $('.logs').empty().append('<div class="alert alert-danger">Something went wrong!</div>');
        console.log('Something went wrong!');
    };

    var alwaysCallback = function () {
        $form.parents('.modal').modal('hide');

        /**
         * DIRTY HACK, problem with model disappear
         */
        $('.modal-backdrop.fade.in').remove();
        GlobalManager.trigger('reload');
    };

    Api.destroy(type, id, csrfToken, doneCallback, failCallback, alwaysCallback, 'DELETE');

};
$("body").on("click",'.ajax-delete-form .ajax-delete-submit', AjaxDeleteForm);
//$('.ajax-delete-form').submit(AjaxDeleteForm);

/**
 * Intercepts sending form
 * do it with ajax
 * all models must have rest api controllers with method @destroy($id)
 * URI: /api/[controller_name]/[id]
 */
var AjaxUnpublishForm=function (event) {

    event.preventDefault();
    var $form = $(this);

    var type = '',
        id = 0,
        csrfToken = '';
    var params = $form.serializeArray();
    var len = params.length;
    for(var i = 0; i < len; i++) {
        if (params[i].name == 'type') {
            type = params[i].value;
        } else if (params[i].name == 'id') {
            id = params[i].value;
        } else if (params[i].name == '_token') {
            csrfToken = params[i].value;
        }
    }

    var doneCallback = function (data) {
        $('.logs').empty().append('<div class="alert alert-info">' + data.message + '</div>');
        if(!data.nodelete)
            $form.parents('tr').remove();
    };
    var failCallback = function () {
        $('.logs').empty().append('<div class="alert alert-danger">Something went wrong!</div>');
        console.log('Something went wrong!');
    };

    var alwaysCallback = function () {
        $form.parents('.modal').modal('hide');

        /**
         * DIRTY HACK, problem with model disappear
         */
        $('.modal-backdrop.fade.in').remove();
        GlobalManager.trigger('reload');
    };

    Api.destroy(type, id, csrfToken, doneCallback, failCallback, alwaysCallback, 'UNPUBLISH');
};
$('.ajax-unpublish-form').submit(AjaxUnpublishForm);

/**
 * Intercepts sending form
 * do it with ajax
 * all models must have rest api controllers with method @destroy($id)
 * URI: /api/[controller_name]/[id]
 */
var AjaxPublishForm=function (event) {

    event.preventDefault();
    var $form = $(this);

    var type = '',
        id = 0,
        csrfToken = '';
    var params = $form.serializeArray();
    var len = params.length;
    for(var i = 0; i < len; i++) {
        if (params[i].name == 'type') {
            type = params[i].value;
        } else if (params[i].name == 'id') {
            id = params[i].value;
        } else if (params[i].name == '_token') {
            csrfToken = params[i].value;
        }
    }

    var doneCallback = function (data) {
        $('.logs').empty().append('<div class="alert alert-info">' + data.message + '</div>');
        if(!data.nodelete)
            $form.parents('tr').remove();
    };
    var failCallback = function () {
        $('.logs').empty().append('<div class="alert alert-danger">Something went wrong!</div>');
        console.log('Something went wrong!');
    };

    var alwaysCallback = function () {
        $form.parents('.modal').modal('hide');

        /**
         * DIRTY HACK, problem with model disappear
         */
        $('.modal-backdrop.fade.in').remove();
        GlobalManager.trigger('reload');
    };

    Api.destroy(type, id, csrfToken, doneCallback, failCallback, alwaysCallback, 'PUBLISH');
};
$('.ajax-publish-form').submit(AjaxPublishForm);

function OnClickPub(model,id)
{
    var a=model.split("@");
    model=a[0];
    var action=a[1];
    var $form = $(this);
    if(action=='publish') {
        Api.publish(model, id, function () {
            $form.parents('.modal').modal('hide');

            /**
             * DIRTY HACK, problem with model disappear
             */
            $('.modal-backdrop.fade.in').remove();
            GlobalManager.trigger('reload');
            GlobalManager.trigger('to-released');
        });
    } else if(action=='unpublish') {
        Api.unpublish(model, id, function () {
            $form.parents('.modal').modal('hide');

            /**
             * DIRTY HACK, problem with model disappear
             */
            $('.modal-backdrop.fade.in').remove();
            GlobalManager.trigger('reload');
            if(model!='survey') {
                GlobalManager.trigger('to-design');
            }
        });
    }else{
        Api.custom(model, id, action, function (data) {
            $form.parents('.modal').modal('hide');

            /**
             * DIRTY HACK, problem with model disappear
             */
            $('.modal-backdrop.fade.in').remove();
            GlobalManager.trigger('reload');
            if(model!='survey') {
                GlobalManager.trigger('to-released');
            }
            if(data.redirect && data.redirect.length) {
                window.location = data.redirect;
            }
        });
    }
    return false;
}